export default __webpack_public_path__ + "static/media/polygon-logo.1140771b.png";